import { motion, useScroll, useSpring } from "framer-motion";
import { WHATSAPP_HREF } from "@/lib/data";

export const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" {...props}>
    <path d="M16.001 3C9.096 3 3.5 8.597 3.5 15.5c0 2.42.687 4.68 1.878 6.6L3 29l7.086-2.337a12.44 12.44 0 0 0 5.915 1.505h.005c6.905 0 12.5-5.597 12.5-12.5S22.906 3 16.001 3Zm0 22.7h-.004a10.36 10.36 0 0 1-5.29-1.45l-.379-.225-3.945 1.3 1.323-3.845-.246-.395a10.36 10.36 0 0 1-1.585-5.585c0-5.735 4.67-10.4 10.408-10.4 2.78 0 5.393 1.083 7.36 3.05a10.34 10.34 0 0 1 3.047 7.362c0 5.735-4.67 10.187-10.29 10.187Zm5.694-7.735c-.312-.156-1.845-.91-2.13-1.014-.286-.104-.494-.156-.702.157-.208.312-.806 1.013-.989 1.222-.182.208-.364.234-.676.078-.312-.156-1.317-.485-2.508-1.547-.927-.827-1.554-1.849-1.736-2.161-.182-.312-.02-.481.137-.636.14-.14.312-.364.468-.546.156-.182.208-.312.312-.52.104-.208.052-.39-.026-.546-.078-.156-.702-1.69-.962-2.315-.253-.61-.51-.527-.702-.537l-.598-.01c-.208 0-.546.078-.832.39-.286.312-1.09 1.066-1.09 2.6 0 1.535 1.116 3.018 1.272 3.226.156.208 2.196 3.353 5.323 4.702.744.321 1.324.513 1.777.657.746.237 1.425.204 1.962.124.599-.089 1.845-.754 2.105-1.484.26-.729.26-1.354.182-1.484-.078-.13-.286-.208-.598-.364Z" />
  </svg>
);

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      style={{ scaleX }}
      className="fixed inset-x-0 top-0 z-[70] h-1 origin-left bg-gold-500"
      data-testid="scroll-progress"
    />
  );
};

export const WhatsAppFab = ({ bottomClass = "bottom-6" }) => (
  <motion.a
    href={WHATSAPP_HREF}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-fab"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 200, damping: 15 }}
    whileHover={{ scale: 1.1 }}
    className={`fixed right-6 z-[65] grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.5)] transition-[bottom] duration-300 ${bottomClass}`}
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-30" />
    <WhatsAppIcon className="relative h-7 w-7" />
  </motion.a>
);
